import React, { Component } from 'react';
import MobileNumberPad from '../../util/mobileNumberPad';

class PreFilter extends Component {

    constructor(props) {
        super(props);
        this.state = { mobile: '', clearInputs: false };

        this.mobileNumberComplete = this.mobileNumberComplete.bind(this);
        this.handleChildUnmount = this.handleChildUnmount.bind(this);
        this.submit = this.submit.bind(this);
    }
    mobileNumberComplete(mobile) {
        this.setState({ mobile: mobile });
    }

    handleChildUnmount() {

    }

    submit() {
        this.props.onSubmit(this.state.mobile);
    }

    render() {

        return (
            <form>
                <h2 className="client-text text-center">Merchant Login</h2>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card text-center p-l-5 p-r-5">
                            {!this.state.clearInputs && <MobileNumberPad strength={8} mobileNumberComplete={this.mobileNumberComplete.bind(this)} autoFocus={true} enabled={true} unmountMe={this.handleChildUnmount} />}

                        </div>
                    </div>
                </div>

                <button disabled={!this.state.mobile} className="btn btn-client btn-lg btn-block" onClick={this.submit} type="button">
                    Continue
                </button>
            </form>

        );
    }
}

export default PreFilter;


// WEBPACK FOOTER //
// ./app/auth/components/mobileNumberVerification.js